import type { Settings } from '@ais-ui/websockets';
import type { DomainTranslator, MessagesSettings } from '../types';

const DEFAULTS: MessagesSettings = {
  lookback_hours: 24,
};

const asRecord = (value: unknown): Record<string, unknown> =>
  value && typeof value === 'object' ? (value as Record<string, unknown>) : {};

const pick = <V>(value: unknown, fallback: V): V =>
  value === undefined || value === null ? fallback : (value as V);

/**
 * Translator for the `messages` domain. Maps the legacy blob's
 * `ribbonPlugin.settings.msg_lookback_hours` to/from the clean
 * `MessagesSettings.lookback_hours`.
 *
 * `msg_area_of_interest` is intentionally NOT handled here — it is backend
 * consumed and stays in the blob until it gets its own per-field treatment.
 */
export const messagesTranslator: DomainTranslator<MessagesSettings> = {
  fromBlob(blob: Settings): MessagesSettings {
    const ribbon = asRecord(blob['ribbonPlugin.settings']);
    return {
      lookback_hours: pick(ribbon.msg_lookback_hours, DEFAULTS.lookback_hours),
    };
  },

  applyToBlob(blob: Settings, patch: Partial<MessagesSettings>): Settings {
    const next = { ...(blob as unknown as Record<string, unknown>) };
    const ribbon = { ...asRecord(next['ribbonPlugin.settings']) };
    if (patch.lookback_hours !== undefined)
      ribbon.msg_lookback_hours = patch.lookback_hours;
    next['ribbonPlugin.settings'] = ribbon;
    return next as unknown as Settings;
  },
};
